var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pageLevel === 1
        ? _c(
            "div",
            { staticClass: "table" },
            [
              _c(
                "div",
                { staticClass: "params-form" },
                [
                  _c(
                    "a-form-model",
                    {
                      ref: "searchForm",
                      attrs: { layout: "inline", model: _vm.formState },
                    },
                    [
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "方案级别", prop: "level" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px",
                              },
                            },
                            [
                              _c("a-ext-local-dic-select", {
                                attrs: { "dic-key": "MonitPlanLevel" },
                                model: {
                                  value: _vm.formState.level,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "level", $$v)
                                  },
                                  expression: "formState.level",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "监测项目名称", prop: "name" } },
                        [
                          _c("a-input", {
                            model: {
                              value: _vm.formState.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "name", $$v)
                              },
                              expression: "formState.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "监测执行时间", prop: "execDate" } },
                        [
                          _c("a-ext-data-picker", {
                            model: {
                              value: _vm.formState.execDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.formState, "execDate", $$v)
                              },
                              expression: "formState.execDate",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "任务完成状态", prop: "status" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px",
                              },
                            },
                            [
                              _c("a-ext-local-dic-select", {
                                attrs: { "dic-key": "MonitTaskPickStatus" },
                                model: {
                                  value: _vm.formState.status,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "status", $$v)
                                  },
                                  expression: "formState.status",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "牵头机构", prop: "leaderName" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px",
                              },
                            },
                            [
                              _c("a-ext-gov-select", {
                                model: {
                                  value: _vm.formState.leaderName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "leaderName", $$v)
                                  },
                                  expression: "formState.leaderName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        { attrs: { label: "执行机构", prop: "execName" } },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                width: "100px",
                              },
                            },
                            [
                              _c("a-ext-gov-select", {
                                model: {
                                  value: _vm.formState.execName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.formState, "execName", $$v)
                                  },
                                  expression: "formState.execName",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                      _c(
                        "a-form-model-item",
                        [
                          _c(
                            "a-space",
                            [
                              _c(
                                "a-button",
                                { on: { click: _vm.onResetSearch } },
                                [_vm._v("重置")]
                              ),
                              _c("a-divider", {
                                attrs: { dashed: "true", type: "vertical" },
                              }),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: { click: _vm.onSearchPage },
                                },
                                [_vm._v("查询")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-content" },
                [
                  _c("div", [
                    _c(
                      "div",
                      {
                        staticClass: "title",
                        staticStyle: {
                          width: "350px",
                          display: "inline-block",
                        },
                      },
                      [
                        _vm._v(" 监测项目管理 "),
                        _vm.selectedRowCount
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "150px",
                                  display: "inline-block",
                                  "line-height": "20px",
                                  color: "darkorange",
                                },
                              },
                              [
                                _vm._v(
                                  " 共选择" +
                                    _vm._s(_vm.selectedRowCount) +
                                    "条 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "btn",
                        staticStyle: {
                          width: "calc(100% - 350px)",
                          display: "inline-block",
                          "text-align": "right",
                        },
                      },
                      [_c("a-space")],
                      1
                    ),
                  ]),
                  _c(
                    "a-config-provider",
                    { attrs: { locale: _vm.locale } },
                    [
                      _c("a-table", {
                        attrs: {
                          "data-source": _vm.dataSource,
                          columns: _vm.columns,
                          pagination: _vm.pagination,
                          loading: _vm.loading,
                          "row-key": "id",
                          scroll: { x: "calc(700px + 80%)", y: 500 },
                        },
                        on: { change: _vm.onPageChange },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "zhuangtai",
                              fn: function (text, record) {
                                return [
                                  record.status === "已完成"
                                    ? _c(
                                        "span",
                                        { staticStyle: { color: "green" } },
                                        [_vm._v("已执行")]
                                      )
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "orange" } },
                                        [_vm._v("执行中")]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "caozuo",
                              fn: function (text, record) {
                                return [
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onProjectDetailModalOpen(
                                            record
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("查看项目详情")]
                                  ),
                                  _c("a-divider", {
                                    attrs: { dashed: "true", type: "vertical" },
                                  }),
                                  _c(
                                    "a-button",
                                    {
                                      attrs: { type: "link" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.goDetailPage(record)
                                        },
                                      },
                                    },
                                    [_vm._v("任务详情")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2844001049
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.projectDetailModalVisable
                ? _c("project-detail-modal", {
                    attrs: {
                      visible: _vm.projectDetailModalVisable,
                      param: _vm.projectDetailModalParam,
                    },
                    on: {
                      "update:visible": function ($event) {
                        _vm.projectDetailModalVisable = $event
                      },
                      addModalClose: _vm.onProjectDetailModalClose,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      _vm.pageLevel === 2
        ? _c("index2", {
            attrs: {
              "project-id": _vm.clickProjectId,
              "task-id": _vm.clickTaskId,
              total: _vm.clickTaskTotal,
            },
            on: { clickIndex3: _vm.onClickIndex3, fanhui: _vm.onFanhui },
          })
        : _vm._e(),
      _vm.pageLevel === 3
        ? _c("index3new", {
            attrs: { "task-id": _vm.clickTaskId, "pick-id": _vm.clickPickId },
            on: { fanhui: _vm.onFanhui2 },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }